import { render } from "./aiDailyPred.vue?vue&type=template&id=689c9fe7"
import script from "./aiDailyPred.vue?vue&type=script&lang=js"
export * from "./aiDailyPred.vue?vue&type=script&lang=js"

import exportComponent from "/home/andre_merino/aihuk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__